module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48Y2lyY2xlIGZpbGw9IiNFRkYzRkIiIGN4PSIxNCIgY3k9IjE0IiByPSIxNCIvPjxwYXRoIGQ9Ik0xNCAxMy40MzRsMy45Ni0zLjk2LjU2NS41NjYtMy45NiAzLjk2IDMuOTYgMy45Ni0uNTY1LjU2NS0zLjk2LTMuOTYtMy45NiAzLjk2LS41NjUtLjU2NSAzLjk2LTMuOTYtMy45Ni0zLjk2LjU2NS0uNTY1IDMuOTYgMy45NnoiIGZpbGw9IiM0NTcwRjUiLz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close-icon.svg
// module id = 179
// module chunks = 0